import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "status-bar" }
const _hoisted_2 = { class: "caption" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]

import { useStore } from "vuex";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";


export default /*@__PURE__*/_defineComponent({
  __name: 'Cancelled',
  setup(__props) {

useStore();

const { hrefTFN, tollFreeNumber, emailAddress, lenderUrl } = useApplicationStatus();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TimelineStep, {
      status: "cancelled",
      title: "Application Cancelled"
    }, {
      caption: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _cache[0] || (_cache[0] = _createTextVNode(" Your application has been cancelled. Thank you for giving us the opportunity to meet your education funding needs! If you would like to reapply click ", -1)),
            _createElementVNode("a", {
              class: "inline-link",
              href: `${_unref(lenderUrl)}`
            }, "here", 8, _hoisted_3),
            _cache[1] || (_cache[1] = _createTextVNode(". To speak with one of our support representatives, please contact us at ", -1)),
            _createElementVNode("a", {
              class: "inline-link",
              href: `mailto:${_unref(emailAddress)}`
            }, _toDisplayString(_unref(emailAddress)), 9, _hoisted_4),
            _cache[2] || (_cache[2] = _createTextVNode(" or ", -1)),
            _createElementVNode("a", {
              class: "inline-link",
              href: `tel:${_unref(hrefTFN)}`
            }, _toDisplayString(_unref(tollFreeNumber)), 9, _hoisted_5),
            _cache[3] || (_cache[3] = _createTextVNode(". Agents are available by phone 24 hours a day, 7 days a week. ", -1))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})